module.exports = __webpack_public_path__ + "img/PlusSign.5c624b2a.svg";